// extracted by mini-css-extract-plugin
export default {"image":"NewFamilyUserScreen_image__YkbCt","body":"NewFamilyUserScreen_body__bDgVB"};